import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const editVariantAPI = createApi('EditVariantSlice', 'PUT');

const EditVariantSlice = createSlice({
  name: 'EditVariantSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(editVariantAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editVariantAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(editVariantAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default EditVariantSlice.reducer;